import React, {useCallback} from 'react';
import PropTypes from "prop-types";
import {OutlineErrorIcon} from "presentation/common/components/style-guide/icons";
import {Button} from "presentation/common/components";
import clsx from "clsx";
import {emptyFn} from "presentation/common/helpers/utils";

import styles from './BillIssuerNotMatchMessage.module.scss';

export const BillIssuerNotMatchMessageContent = (props) => {
  const {Icon = OutlineErrorIcon, onClose, onCancel} = props;

  const closeFn = useCallback(
    () => {
      onCancel && onCancel();
      onClose && onClose();
    },
    [onCancel, onClose]);

  return (
    <div className={styles.container}>
      <div className="text-center mb-0 lg:mb-3"><Icon stroke="#FFB350"/></div>
      <div className="pb-2 lg:pb-0">
        <h3 className={clsx("text-lg text-center lg:pt-1 pb-1", styles.title)}>¡Seleccione otro emisor de factura!</h3>
        <p className={clsx("text-center pb-8", styles.message)}>
          El emisor de factura seleccionado no se corresponde con la factura adjuntada.
        </p>
      </div>

      <div className="text-center">
        <Button label="Aceptar" onClick={closeFn}/>
      </div>
    </div>
  );
};

BillIssuerNotMatchMessageContent.defaultProps = {
  onClose: emptyFn,
};

BillIssuerNotMatchMessageContent.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  onCancel: PropTypes.func,
};

export default React.memo(BillIssuerNotMatchMessageContent);
